import React, { useState } from 'react';

import { AutoPlayIcon, PauseBtn } from 'public/assets';
import styled from '@emotion/styled';
import { isDevelopment } from '@/common/utils';

interface IAutoPlay {
  type: 'play' | 'pause' | 'hidden';
  playRate: number;
  onPress: (isPlay: boolean) => void;
  onRate: (rate: number) => void;
}

const getRate = (prevRate: number) => {
  if (isDevelopment())
    return prevRate === 1.0
      ? 1.5
      : prevRate === 1.5
      ? 2.0
      : prevRate === 2.0
      ? 200.0
      : 1.0;

  return prevRate === 1.0
    ? 1.5
    : prevRate === 1.5
    ? 2.0
    : prevRate === 2.0
    ? 3.0
    : 1.0;
};

const AutoPlay = ({ type, playRate = 1.0, onPress, onRate }: IAutoPlay) => {
  const [rate, setRate] = useState<number>(playRate);

  if (type === 'hidden') {
    return null;
  }

  const onPressRate = () => {
    const autoRate = getRate(rate);
    setRate(autoRate);
    onRate(autoRate);
  };

  return (
    <Container>
      <div
        className="button"
        onClick={() => {
          onPress(type === 'pause');
        }}
      >
        {type === 'pause' ? (
          <AutoPlayIcon width={64} height={64} />
        ) : (
          <PauseBtn width={64} height={64} />
        )}
      </div>

      <div className="button" onClick={onPressRate}>
        <div className="button-bg"></div>
        <div className="rate">{rate.toFixed(1)}x</div>
      </div>
    </Container>
  );
};

const Container = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 32px;

  .button {
    width: 4em;
    height: 4em;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    cursor: pointer;

    svg {
      z-index: 1;
    }
  }

  .button-bg {
    position: absolute;
    width: 4em;
    height: 4em;
    background-color: black;
    opacity: 0.5;
    border-radius: 50%;
  }

  .pause {
    position: relative;
    height: 1.25em;
    width: 4px;
    background: ${({ theme }) => theme.colors.white};
  }

  .play {
    position: absolute;
    width: 32px;
    height: 32px;
    left: 61px;
    top: 29px;

    /* GRAY/White */

    background: #ffffff;
    border-radius: 2.25px;
    transform: rotate(90deg);
  }

  .rate {
    position: relative;
    font-family: SF Pro Display, -apple-system, BlinkMacSystemFont, helvetica,
      Arial, 'Apple SD Gothic Neo', sans-serif;
    font-weight: bold;
    font-size: 1.25em;
    line-height: 28px;

    color: ${({ theme }) => theme.colors.white};
    text-align: center;
  }
`;

export default AutoPlay;
